"use client";

import React from "react";
import { Card, CardFooter, Avatar, Button, Image } from "@nextui-org/react";


import { Job } from "@/types/types";

interface FeaturesTableProps {
    job: Job;
}

const CVComponent: React.FC<FeaturesTableProps> = ({ job }) => {
    return (
        <Card
            isFooterBlurred
            radius="lg"
            className="border-none m-2"
        >
            <div className="flex items-center justify-center w-48 h-64 border-0 rounded-2xl bg-gradient-to-br from-red-500 to-indigo-900 shadow-lg hover:from-pink-500 hover:to-yellow-500">
                <Image src="/pdf.png" alt="Avatar" className="rounded-t-xl hover:scale-50" width={100} height={48} />
            </div>
            <CardFooter className="justify-between before:bg-white/10 border-white/20 border-1 overflow-hidden py-1 absolute before:rounded-xl rounded-large bottom-1 w-[calc(100%_-_8px)] shadow-small ml-1 z-10">
                <p className="text-tiny text-white/80">Bientôt Disponible</p>
                <Button className="text-tiny text-white bg-black/20 p-4" variant="flat" color="default" radius="md" size="sm">
                    Notifiez Moi <br /> 😊
                </Button>
            </CardFooter>
        </Card>
    );
}

export default CVComponent;